import React, {Component} from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import School from "../../../models/School";
import GroundFloorDurableFunctionInstanceList from "../../GroundFloorDurableFunctionInstanceList";
import {GroundFloorDurableFunctionInstance} from "../../../models/DurableFunctionInstance";
import ApiService from "../../ApiService";
import { WorkloadInstanceQuery } from '../../../models/WorkloadInstanceQuery';
import * as H from "history";
import {buildIndexedSchools} from "../../../utils/IndexedSchools";
import moment from "moment";
import LoadingPage from "../../LoadingPage";
import {Link} from "react-router-dom";
import {CommandBarButton} from "office-ui-fabric-react";

interface BulkWorkloadPageProps {
    apiService: ApiService;
    history: H.History;
}

interface BulkWorkloadPageState {
    allSchools?: School[];
    bulkInstances?: GroundFloorDurableFunctionInstance[];
}

class BulkWorkloadPage extends Component<BulkWorkloadPageProps & DispatchProps ,BulkWorkloadPageState> {
    static displayName = BulkWorkloadPage.name;
    
    constructor(props: BulkWorkloadPageProps & DispatchProps) {
        super(props);
        
        this.state = {
            allSchools: undefined,
            bulkInstances: undefined,
        }
    }

    async componentDidMount(){
        const allSchools = await this.props.apiService.getSchoolsAdmin(false,true,false,[],[],"");
        const query = WorkloadInstanceQuery.withDefaults();
        query.fromDate = moment().subtract(1,'years').toDate();
        query.isBulkWorkload = true;
        
        const bulkInstances = await this.props.apiService.getGroundFloorDurableFunctionInstances(query);
        
        this.setState({
            allSchools: allSchools,
            bulkInstances: bulkInstances
        });
    }

    async componentDidUpdate(prevProps: Readonly<BulkWorkloadPageProps & DispatchProps>, prevState: any): Promise<void> {

    }    
    
    render() {
        
        if(this.state.allSchools === undefined || this.state.bulkInstances === undefined)
        {
            return <LoadingPage/>;
        }
        
        const newLink =(
            <Link to={"/cdb-admin/workloads/bulk/new"}>
                <CommandBarButton
                    iconProps={{ iconName: "Rocket" }}
                    text="Start New"
                />
            </Link>
        );
        
        return(
            <GroundFloorDurableFunctionInstanceList
                instances={this.state.bulkInstances}
                indexedSchools={buildIndexedSchools(this.state.allSchools!)}
                title="Bulk Workloads"
                enableRowLinks={true}
                virtualize={true}
                headerExtra={newLink}/>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): BulkWorkloadPageProps => {
        return {
            apiService: state.auth.apiService,
            history: ownProps.history,
        };
    }
)(BulkWorkloadPage)